var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1403_1062)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.5,
    cy: 27.7848,
    rx: 23.5,
    ry: 23.7848,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 27.7848C49.5 40.1095 39.6333 50.0697 27.5 50.0697C15.3667 50.0697 5.5 40.1095 5.5 27.7848C5.5 15.4602 15.3667 5.5 27.5 5.5C39.6333 5.5 49.5 15.4602 49.5 27.7848Z",
    stroke: "#CD2A3F",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.659 38.006C24.8725 38.0067 25.0834 37.9596 25.2762 37.8681C25.4691 37.7766 25.639 37.6431 25.7735 37.4773L32.6749 28.9041C32.8851 28.6484 33 28.3277 33 27.9967C33 27.6658 32.8851 27.3451 32.6749 27.0894L25.5306 18.5162C25.2881 18.2244 24.9396 18.0409 24.5617 18.006C24.1839 17.9712 23.8077 18.0879 23.5159 18.3304C23.2241 18.573 23.0406 18.9215 23.0058 19.2993C22.9709 19.6771 23.0876 20.0533 23.3301 20.3451L29.7172 28.0039L23.5445 35.6626C23.3697 35.8724 23.2588 36.1277 23.2246 36.3986C23.1905 36.6694 23.2347 36.9444 23.3519 37.1909C23.4692 37.4374 23.6546 37.6452 23.8862 37.7896C24.1179 37.9341 24.386 38.0091 24.659 38.006Z",
    fill: "#CD2A3F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1403_1062",
    x: 0,
    y: 0,
    width: 55,
    height: 55.5698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1403_1062"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1403_1062",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderNextIcon);
export default __webpack_public_path__ + "static/media/sliderNextIcon.b78ea8bc9a8770c55ac776623200c3fe.svg";
export { ForwardRef as ReactComponent };